import { render, staticRenderFns } from "./ScLogin.vue?vue&type=template&id=9f5fa3ae&scoped=true&"
import script from "./ScLogin.vue?vue&type=script&lang=js&"
export * from "./ScLogin.vue?vue&type=script&lang=js&"
import style0 from "./ScLogin.vue?vue&type=style&index=0&id=9f5fa3ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5fa3ae",
  null
  
)

export default component.exports